// extracted by mini-css-extract-plugin
export default {"wrapper":"Z6hXd4EnENUrUm_3wMCwgEmGOO36xio9"};